import EChatStreamEventType from "../enums/EChatStreamEventType";
const AI_ASSISTANT_PROCESSOR_URL =
  process.env.VUE_APP_AI_ASSISTANT_PROCESSOR_URL;

export function createChatStream({
  streamId,
  onMessage,
  onError,
  onAbort,
  onComplete,
} = {}) {
  let opened = false;
  let hasReceivedText = false;
  let closed = false;
  const eventSource = new EventSource(
    AI_ASSISTANT_PROCESSOR_URL + `/aiAssistantProcessor/stream?streamId=${streamId}`, {
			withCredentials: true
		}
  );

  const closeEventSource = () => {
    if (closed) return;

    closed = true;
    eventSource.close();
  };

  eventSource.onopen = () => {
    opened = true;
  };

  setTimeout(() => {
    if (!opened) {
      closeEventSource();
      onError?.(new Error("Stream did not open in time"));
    }
  }, 5000)

  eventSource.onmessage = (event) => {
    if (!event.data)
      return;

    const data = JSON.parse(event.data);

    switch (data.type) {
      case EChatStreamEventType.Delta:
        if (data.delta)
          hasReceivedText = true;
        onMessage?.(data.delta);
        break;
      case EChatStreamEventType.Complete:
        onComplete?.({ empty: !hasReceivedText });
        closeEventSource();
        break;
      case EChatStreamEventType.Error:
        closeEventSource();
        onError?.(data.error);
        break;
    }
  };

  eventSource.onerror = (event) => {
    if (closed) return;

    onError?.(event);
    closeEventSource();
  };

  return {
    close() {
      closeEventSource();
      onAbort?.();
    },
  };
}

export default createChatStream;
